import React, { useEffect, useState } from "react";
import {
  getCollectionByType,
  getCollectionById,
} from "../services/nonAuthRequets";
import ProductCards from "./ProductCards";
import PaginateComponent from "./PaginateComponent";
import LoadingComponent from "./LoadingComponent";
import NoResultsComponent from "./NoResultsComponent";
const FeaturedProducts = ({ collectionId }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [collectionData, setCollectionData] = useState(null); // initialize as null
  const pageSize = 18;

  const fetchCollectionData = async (page = 0) => {
    setLoading(true);
    try {
      
      const fetchedCollectionData = await getCollectionById(
        collectionId,
        page,
        pageSize
      );
      // console.log("Featured Products",fetchedCollectionData);
      setCollectionData(fetchedCollectionData);
      // setProducts((prevProducts) => {
      //   const updatedProducts = [...prevProducts, ...fetchedCollectionData.publicProducts.content];
      //   // Remove duplicate products based on id
      //   return Array.from(new Map(updatedProducts.map((p) => [p.id, p])).values());
      // });
      setProducts(fetchedCollectionData.publicProducts.content);
      setTotalPages(fetchedCollectionData.publicProducts.totalPages);
    } catch (error) {
      console.error("Error fetching collection data:", error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };
  // Fetch collection data once on mount
  useEffect(() => {
    // Reset products and currentPage when collectionId changes
    setProducts([]);
    setCurrentPage(0);
    fetchCollectionData(0);
  }, [collectionId]);

  // Fetch data when currentPage changes (except the initial fetch handled above)
  useEffect(() => {
    // Avoid re-fetching page 0 if it was just fetched on collectionId change
    if (currentPage !== 0) {
      fetchCollectionData(currentPage);
    }
  }, [currentPage]);
  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  if (loading) {
    return <LoadingComponent message="Loading products..." />;
  }
  if (products.length === 0) {
    return <NoResultsComponent message="No products found" />;
  }
  document.title = `${
    collectionData && collectionData.displayName
      ? collectionData.displayName
      : "Featured Products"
  } | Bigmall`;
  return (
    <>
      <ProductCards
        products={products}
        currentPage={currentPage}
        totalPages={totalPages}
        //loadMoreProducts={loadMoreProducts}
        showLoadmore={false}
        title={
          collectionData ? collectionData.displayName : "Featured Products"
        }
        //collectionStatus={collectionData ? collectionData.status : "inactive"}
      />
      <div className="container">
        <PaginateComponent
          totalPages={totalPages}
          handlePageClick={handlePageClick}
          currentPage={currentPage}
        />
      </div>
    </>
  );
};

export default FeaturedProducts;
